import { Descriptions, DescriptionsProps } from "antd";
import React from "react";
import styled from "styled-components";

export const UserPanel = styled.div`
  background-color: #fff;
  width: 220px;
`;
export const BaseInfo = styled.div`
  display: flex;
`;
export const Info = styled.div`
  padding-left: 8px;
  width: 50%;
  text-align: center;
  h3 {
    margin-bottom: 0;
    line-height: 1.17em;
  }
  p {
    margin-bottom: 0;
    font-size: 12px;
    color: #8c8c8c;
    .ant-typography {
      color: #8c8c8c;
    }
  }
`;
export const OtherInfo = styled(Descriptions as React.ComponentType<DescriptionsProps>)`
  margin-top: 10px;
  .ant-descriptions-item {
    padding-bottom: 0 !important;
    .ant-descriptions-item-label {
      font-size: 12px;
      color: #bfbfbf;
      padding-right: 4px;
      &::after {
        display: none;
      }
    }
    .ant-descriptions-item-content {
      border-top: 2px solid black;
      width: 100%;
      display: table-cell;
    }
  }
`;

export const TypographyWrapper = styled.div`
  display: flex;
  border-bottom: 1px solid darkblue;
  h5 {
    margin-top: 1em;
    margin-left: 0.5em;
    width: 30%;
  }
  span {
    align-self: end;
    margin: 0 auto;
  }
`;
